import styled from 'styled-components'


export const OutlinedButton = styled.button`
    border: 1px solid #F9CA26;
    border-radius: 10px;
    padding: 10px 20px;
    text-decoration: none;
    color: #F9CA26;
    background-color: #161A31;
    transition: 0.3s;
    font-size: 1em;
    font-weight: bold;
    cursor: pointer;
    outline: none;

    &:hover {
        color: #000;
        background-color: #F9CA26;
    }
`;

export const ContainedButton = styled.button`
    border: 1px solid #F9CA26;
    border-radius: 10px;
    padding: 10px 20px;
    text-decoration: none;
    color: #000;
    background-color: #F9CA26;
    transition: 0.3s;
    font-size: 1em;
    font-weight: bold;
    cursor: pointer;
    outline: none;

    &:hover {
        color: #000;
        background-color: #F9CA26;
    }
`;